export enum ProcessStatus {
    OK = 'OK',
    PENDING = 'PENDING',
    FAIL = 'FAIL',
    INVALID = 'INVALID',
    VALIDATED= 'VALIDATED'
}